var $8209822dd94e7701$exports = {};
$8209822dd94e7701$exports = {
    "collectionLabel": `\u{C81C}\u{C548}`
};


export {$8209822dd94e7701$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
